import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { CstNavigationService } from "src/app/services/cst-navigation.service";
import { UserService } from "src/app/services/user.service";
import { AnlageDetailDto, AnlagenClientProvider } from "src/app/web-api/web-api";

@Component({
    selector: "app-infoportal-api-elevators-display-notes",
    templateUrl: "./elevators-displayNotes.component.html",
    styleUrls: ["./elevators-displayNotes.component.scss", "../../styles.scss"],
    standalone: false
})
export class InfoportalApiElevatorDisplayNotesComponent {
    private _userService = inject(UserService);
    private _route = inject(ActivatedRoute);
    private _anlagenClient = inject(AnlagenClientProvider);
    private _navigation = inject(CstNavigationService);


    public anlagenIDToDisplay: number = null;
    public data: AnlageDetailDto = null;
    facilityNoInternal = "";

    constructor() {
        this._route.paramMap.subscribe((params) => {
            this.anlagenIDToDisplay = +params.get("id"); // + um den string in eine number zu wandeln
            if (this.anlagenIDToDisplay) {
                this._LadeAnlage().subscribe();
            }
        });
    }

    public get user() {
        return this._userService?.CurrentUser;
    }

    private _LadeAnlage(): Observable<any> {
        this.data = null;
        this.facilityNoInternal = "";
        return this._anlagenClient.getSingle(this.anlagenIDToDisplay).pipe(
            catchError((err) => {
                if (err.status === 403) {
                    this._navigation.navigateTo_Infoportal_Elevators();
                }
                return throwError(err);
            }),
            map((anlageDto) => {
                this.data = anlageDto;
                this.facilityNoInternal = this.data.anlageNrIntern;
                return anlageDto;
            })
        );
    }

}
